module.exports = __webpack_public_path__ + "static/img/1.a7127ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/zh/1.png
// module id = 3SBF
// module chunks = 0